<template>
  <div class="pm-dialog-order-at">
    <div class="vs-row w-full flex justify-center">

      <div class="flex items-start justfy-center">

        <div class="pm-time-subtitle">日付</div>
        <div class="order-at-date">
          <div class="display-date">
            {{date}}
          </div>
          <div class="w-full">
            <div class="flex items-bottom justify-center" >
              <div class="pm-time-spin-button" @mousedown="onDateDown">
                <feather-icon icon="TriangleIcon" :svgClasses="['h-4', 'w-4', { 'fill-current': isPastYesterday } ]" style="transform: rotate(-90deg);" :style="{ color: isPastYesterday ? '#e0e0e0' : '#bdbdbd' }" />
              </div>
              <div class="pm-time-spin-button" @mousedown="onDateUp"  >
                <feather-icon icon="TriangleIcon" :svgClasses="['h-4', 'w-4', { 'fill-current': isFutureThanLimitday } ]" style="transform: rotate(90deg);color:#bdbdbd;" />
              </div>
            </div>
          </div>
        </div>

        <div class="pm-time-subtitle pm-time-margin">時刻</div>
        <div @mousedown="selectedInput = 0" >
          <vs-input-number
            v-model="hour"
            color="#bdbdbd"
            :min="0"
            :max="23"
            class="order-at-input"
            :class="[
              ( ( !hour && hour !== 0 )  ? 'input-null' : ( !validHour ? 'input-invalid' : 'input-any' ) ),
              ( this.selectedInput === 0 ? 'border-selected' : null )
            ]"
          />
        </div>
        <div class="pm-time-subtitle">：</div>
        <div @mousedown="selectedInput = 1" >
          <vs-input-number
            v-model="minute"
            color="#bdbdbd"
            :min="0"
            :max="59"
            class="order-at-input"
            :class="[
              ( ( !minute && minute !== 0 ) ? 'input-null' : ( !validMinute ? 'input-invalid' : 'input-any' ) ),
              ( this.selectedInput === 1 ? 'border-selected' : null )
            ]"
          />
        </div>
      </div>

    </div>
    <div class="vs-row flex justify-center">
      <div v-for="(master,index) in masterList" :key="index" class="candidate-list" @mousedown="onKeyDown(master.id)" >
        <vs-chip
          color="#828282"
          onMouseOut="this.style.background='#828282'"
          onMouseOver="this.style.background='#346c88'"
        >
          {{ master.name }}
        </vs-chip>
      </div>
    </div>

    <div class="vs-row flex justify-center">
      <vs-button
        class="flex justify-center items-center current-time-button"
        color="#828282"
        onMouseOut="this.style.background='#828282'"
        onMouseOver="this.style.background='#346c88'"
        @mousedown="onSetNow"
      >現在時刻</vs-button>
      <vs-button
        class="flex justify-center items-center clear-button"
        color="#828282"
        onMouseOut="this.style.background='#828282'"
        onMouseOver="this.style.background='#346c88'"
        @mousedown="onClear"
      >クリア</vs-button>
    </div>
    <div class="flex justify-center">
      <vs-button
        :color="validDate ? '#2d9cdb' : '#bdbdbd'"
        :disabled="!validDate"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="validDate ? '#2d9cdb' : '#bdbdbd'"
        :disabled="!validDate"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMasterDestinationWork");
import moment from "moment-timezone";

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true, default: {} },
  },
  data() {
    return {
      selectedInput: 0,
      ymd: "",
      date: "",
      hour: null,
      minute: null,
      startMomentYmdhms: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return [
        { id: 0, name: 0 },
        { id: 1, name: 1 },
        { id: 2, name: 2 },
        { id: 3, name: 3 },
        { id: 4, name: 4 },
        { id: 5, name: 5 },
        { id: 6, name: 6 },
        { id: 7, name: 7 },
        { id: 8, name: 8 },
        { id: 9, name: 9 },
      ];
    },
    displayDate() {
      return moment(this.date).format("MM/DD")
    },
    validDate(){
      if ( !this.validHour || !this.validMinute ) {
        return null;
      }
      const hour   = ( '00' + this.hour   ).slice(-2);
      const minute = ( '00' + this.minute ).slice(-2);
      let timeStr = `${this.ymd.slice(0,4)}-${this.ymd.slice(4,6)}-${this.ymd.slice(6,8)}T${hour}:${minute}:00`;
      if ( ! moment(timeStr).isValid() ) {
        return null;
      } else if ( moment(timeStr).valueOf() < moment(this.startMomentYmdhms).valueOf() ) {
        // 当日の営業開始時間よりも前の時刻は無効扱い
        return null;
      }
      return isNaN(new Date(timeStr)) ? null : new Date(timeStr);
    },
    validHour() {
      return this.hour === 0 || this.hour && !isNaN(this.hour) &&  Number(this.hour) < 24
    },
    validMinute() {
      return this.minute === 0 || this.minute && !isNaN(this.minute) &&  Number(this.minute) < 60
    },
    isPastYesterday() {
      if ( !this.ymd ) {
        return;
      }

      const hour   = this.validDate ? ( '00' + this.hour   ).slice(-2) : '00';
      const minute = this.validDate ? ( '00' + this.minute ).slice(-2) : '00';
      const timeStr = `${this.ymd.slice(0,4)}-${this.ymd.slice(4,6)}-${this.ymd.slice(6,8)}T${hour}:${minute}:00`;
      if ( moment(timeStr).add(-1, 'days').valueOf() < moment(this.startMomentYmdhms).startOf('day').valueOf() ) {
        // １日前にすると、過去日付になってしまう場合は、true;
        return true;
      }
      return false;
    },
    isFutureThanLimitday() {
      if ( !this.ymd ) {
        return;
      }
      const selectableDays = 5;
      const hour   = this.validDate ? ( '00' + this.hour   ).slice(-2) : '00';
      const minute = this.validDate ? ( '00' + this.minute ).slice(-2) : '00';
      const timeStr = `${this.ymd.slice(0,4)}-${this.ymd.slice(4,6)}-${this.ymd.slice(6,8)}T${hour}:${minute}:00`;
      if ( moment(timeStr).add(1, 'days').add(1, 'hours').valueOf() > moment().add(selectableDays + 1, 'days').valueOf() ) {
        // １日後にすると、今日から５日後になってしまう場合は、true;
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions([
      "getTargetYmd",
    ]),
    initData() {
      this.selectedInput = 0;
      this.ymd    = this.valueMap && this.valueMap.value ? moment(this.valueMap.value).local().format("YYYYMMDD") : this.valueMap.date;
      this.date   = this.valueMap && this.valueMap.value ? moment(this.valueMap.value).local().format("MM/DD") : `${this.valueMap.date.slice(4,6)}/${this.valueMap.date.slice(6,8)}` ;
      this.hour   = this.valueMap && this.valueMap.value ? moment(this.valueMap.value).local().format("HH") : "" ;
      this.minute = this.valueMap && this.valueMap.value ? moment(this.valueMap.value).local().format("mm") : "" ;
      const hourIntervalObj = this.masterMap['tasks'].find(x => x.id === 'hour_interval');
      let hourIntervalString = hourIntervalObj ? hourIntervalObj.value : "00:00";
      this.startMomentYmdhms = moment().local().format("HH:mm") >  hourIntervalString
        ?  `${moment().local().format("YYYY-MM-DD")}T${hourIntervalString}:00`
        :  `${moment().local().add(-1, 'days').format("YYYY-MM-DD")}T${hourIntervalString}:00`;

    },
    onDateUp() {
      if ( this.isFutureThanLimitday ) {
        return;
      }
      const hour   = this.validDate ? ( '00' + this.hour   ).slice(-2) : '00';
      const minute = this.validDate ? ( '00' + this.minute ).slice(-2) : '00';
      const timeStr = `${this.ymd.slice(0,4)}-${this.ymd.slice(4,6)}-${this.ymd.slice(6,8)}T${hour}:${minute}:00`;
      this.ymd = moment(timeStr).add(1, 'days').format('YYYYMMDD');
      this.date = moment(timeStr).add(1, 'days').format('MM/DD');
    },
    onDateDown() {
      if ( this.isPastYesterday ) {
        return;
      }
      const hour   = this.validDate ? ( '00' + this.hour   ).slice(-2) : '00';
      const minute = this.validDate ? ( '00' + this.minute ).slice(-2) : '00';
      const timeStr = `${this.ymd.slice(0,4)}-${this.ymd.slice(4,6)}-${this.ymd.slice(6,8)}T${hour}:${minute}:00`;
      this.ymd = moment(timeStr).add(-1, 'days').format('YYYYMMDD');
      this.date = moment(timeStr).add(-1, 'days').format('MM/DD');
    },
    onKeyDown(key){
      if ( this.selectedInput === 0) {
        this.hour = this.hour && ( this.hour * 10 + key ) % 100 < 24 ? ( this.hour * 10 + key ) % 100 : key;
      }
      if ( this.selectedInput === 1) {
        this.minute = this.minute && ( this.minute * 10 + key ) % 100 < 60 ? ( this.minute * 10 + key ) % 100 : key;
     }
    },
    onSetNow() {
      this.ymd    = this.valueMap.date;
      this.date   = this.ymd.slice(4,6) + '/' + this.ymd.slice(6,8);
      this.hour   = moment().local().format("HH");
      this.minute = moment().local().format("mm");
    },
    onClear() {
      if ( this.selectedInput === 0) {
        this.hour   = "";
      }
      if ( this.selectedInput === 1) {
        this.minute = "";
      }
    },
    async onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = this.validDate;
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-order-at {
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .order-at-date {
    width: 7rem ;
    input {
      width: 6rem ;
    }
  }
  .display-date {
    margin: 0.2rem 0.5rem !important;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: #f2f2f2;
    font-size: 160%;
    font-weight: bold;
    text-align: center;
    line-height: 2.6rem;
    height: 4rem;
    padding: .7rem;
    color: inherit;
    position: relative;
    border-radius: 4%;
    box-sizing: border-box;
    width: 6rem;
  }
  .order-at-input {
    margin: 0.2rem 0.5rem !important;
    border-radius: 4%;
    input {
      height: 4rem !important;
      min-width: 3.2rem !important;
      border-radius: 4%;
      font-weight: bold;
      font-size: 150% !important;
    }
  }
  .pm-time-subtitle {
    padding-top: 1.5rem;
  }
  .pm-time-margin {
    margin-left: 1.2rem;
  }
  .pm-time-spin-button {
    margin: 0.2rem 1.4rem 1rem 1.4rem ;
  }

  .current-time-button {
    margin: 1rem;
    width:  8rem;
  }
  .clear-button {
    margin: 1rem;
    width:  8rem;
  }
  .border-selected {
    border: 0.2rem solid $pm-blue !important;
    box-sizing: border-box;
  }
  .vs-con-input-label  {
    width: 4rem;
    margin: 2rem 0;
    .vs-input--input {
      height: 3rem;
      text-align: center;
      background-color: $pm-white;
    }
  }
  .input-any {
    background-color: $pm-white;
  }
  .input-null {
    background-color: $pm-light-gray;
  }
  .input-invalid {
    background-color: rgba(203,57,79,0.4);
  }

  .vs-input-number  {
    margin-bottom: 2rem !important;
    padding: 1rem 0;
    height: 4rem;
    width: 4rem;
    border: 0.05rem solid $pm-mouse-gray;
    border-radius: 0.2rem;
    input {
      min-width: 2.4rem ;
    }
    &--button-less{
      height: 1.5rem;
      min-width: 1.8rem;
      transform:translate(1.4rem,3.2rem) !important;
    }
    &--button-plus{
      height: 1.5rem;
      min-width: 1.8rem;
      transform:translate(-1.4rem,3.2rem) !important;
    }
  }

  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

